import { SyntheticEvent,useEffect, useState } from 'react';
import { Outlet, useLocation,useParams } from 'react-router-dom';

import {
    Tabs,
} from '@mui/material';
import { StyledTab } from 'common/components/StyledTab';
import { Routes, RoutesNameMap } from 'common/constants/routes';
import { useAuthContext } from 'common/contexts/AuthContext';
import { isDisabledRoute } from 'common/utils/DisabledRouteEvaluator';
import { replaceLocation } from 'common/utils/locationHelpers';

export const Acls = () => {
    const [currentTab, setCurrentTab] = useState<Routes>(Routes.AclResources);
    const location = useLocation();
    const { currentUserRoles } = useAuthContext();

    useEffect(() => {
        const replacedLastSegment = replaceLocation(
            lastPathSegment => lastPathSegment === Routes.Acls,
            `${location.pathname}/${Routes.AclResources}`);
        setCurrentTab(replacedLastSegment as Routes);
    }, [location]);

    const params = useParams();
    const getTabLink = (key?: string) => (
        `/${Routes.ApplicationSuites}/${params.suiteId}/${Routes.Tenants}/${params.tenantId}/${Routes.Acls}/${key}`
    );

    const handleChangeTab = (_event: SyntheticEvent, newValue: Routes) => {
        setCurrentTab(newValue);
    };

    return (
        <>
            <Tabs
                sx={{ mt: '60px',  mb: '-60px', zIndex:1100, width: '44rem' }}
                onChange={handleChangeTab}
                value={currentTab}
            >
                <StyledTab
                    disabled={false}
                    label={RoutesNameMap.get(Routes.AclResources)}
                    key={Routes.AclResources}
                    link={getTabLink(Routes.AclResources)}
                    value={Routes.AclResources}
                />
                <StyledTab
                    disabled={isDisabledRoute(Routes.AclAccesses, currentUserRoles)}
                    label={RoutesNameMap.get(Routes.AclAccesses)}
                    key={Routes.AclAccesses}
                    link={getTabLink(Routes.AclAccesses)}
                    value={Routes.AclAccesses}
                />
            </Tabs>
            <Outlet />
        </>
    );
};
